import { palette } from "../../theme/palette";
import { View } from "../View";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  sectionLabel: {
    width: "24px",
    height: "24px",
    borderRadius: "0.125rem",
  },
}));

const SectionLabel = ({ section, ...rest }) => {
  const styles = useStyles();
  return (
    <View
      style={{
        display: "inline-block",
        background: section.colour?.colour || palette.translucentBlack,
      }}
      className={styles.sectionLabel}
      {...rest}
    ></View>
  );
};

export default SectionLabel;
